module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "box"
  }, [(_vm.publishToDashboardModel) ? _c('div', [(_vm.publishToDashboardModel) ? _c('uiv-modal', {
    attrs: {
      "footer": false,
      "title": "Publish " + _vm.publishToDashboardModel.resultType + " to Dashboard",
      "backdrop": false
    },
    model: {
      value: (_vm.showPublishToDashboardDialog),
      callback: function($$v) {
        _vm.showPublishToDashboardDialog = $$v
      },
      expression: "showPublishToDashboardDialog"
    }
  }, [_c('publish-to-dashboard-dialog', {
    attrs: {
      "value": _vm.publishToDashboardModel,
      "modelServices": _vm.modelServices,
      "reportServices": _vm.reportServices
    },
    on: {
      "dialogClosed": _vm.onPublishToDashboardDialogClosed
    }
  })], 1) : _vm._e()], 1) : _vm._e(), _vm._v(" "), _c('div', {
    staticClass: "box-header"
  }, [_c('h3', {
    staticClass: "box-title"
  }, [_vm._v(_vm._s(_vm.modelId) + " Dashboards ")])]), _vm._v(" "), _c('div', {
    staticClass: "box-body"
  }, [_c('div', {
    staticClass: "nav-tabs-custom"
  }, [_c('ul', {
    staticClass: "nav nav-tabs",
    attrs: {
      "id": "navTabs"
    }
  }, [_c('li', {
    staticClass: "viewTabLi active",
    attrs: {
      "id": "active-jobs-li"
    }
  }, [_c('a', {
    attrs: {
      "href": "#dashboard-tools-tab",
      "data-toggle": "tab"
    },
    on: {
      "click": function($event) {
        return _vm.tabChanged("tools")
      }
    }
  }, [_vm._v("Dashboards")])]), _vm._v(" "), _c('li', {
    staticClass: "viewTabLi"
  }, [_c('a', {
    attrs: {
      "href": "#view-dashboard-tab",
      "data-toggle": "tab"
    },
    on: {
      "click": function($event) {
        return _vm.tabChanged("viewer")
      }
    }
  }, [_vm._v("Viewer")])])])]), _vm._v(" "), _c('div', {
    staticClass: "tab-content",
    staticStyle: {
      "padding": "0px"
    }
  }, [_c('div', {
    staticClass: "tab-pane active",
    attrs: {
      "id": "dashboard-tools-tab"
    }
  }, [_c('div', {
    staticStyle: {
      "height": "30%",
      "width": "100%"
    }
  }, [_c('btn', {
    staticClass: "btn btn-default",
    on: {
      "click": _vm.publishToDashboard
    }
  }, [_vm._v(" Export to Dashboard")])], 1)]), _vm._v(" "), _vm._m(0)])])])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "tab-pane",
    attrs: {
      "id": "view-dashboard-tab"
    }
  }, [_c('div', {
    staticClass: "row",
    attrs: {
      "id": "diagramOptionsRow"
    }
  }), _vm._v(" "), _c('div', {
    staticStyle: {
      "height": "30%",
      "width": "100%"
    },
    attrs: {
      "id": "dashboardContainer"
    }
  })])
}]}
module.exports.render._withStripped = true
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
     require("vue-hot-reload-api").rerender("data-v-42ce7fd0", module.exports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-42ce7fd0"}!./~/vue-loader/lib/selector.js?type=template&index=0!./ClientApp/components/dashboard/dashboard.vue.html
// module id = 1098
// module chunks = 0